import { gql } from '@src/lib/gql'

export const APPLY_TO_BOARD_SEAT = gql`
  mutation ApplyToBoardSeat($input: ApplyToBoardSeatInput!) {
    applyToBoardSeat(input: $input) {
      groupCommitment {
        id
        groupCommitmentId
        createdAt
        submittedAt
      }
      advisorEngagement {
        id
        advisorEngagementId
        statusKey
      }
    }
  }
`
